<template>
  <div>
    <app-divider v-if="comms.length" class="my-150">Communications</app-divider>

    <comm-log-item
      v-for="(comm, index) in comms"
      :key="`${comm.id}_${index}`"
      :comm="comm"
      show-type-icons
      show-user-avatar
    ></comm-log-item>

    <app-divider class="my-150">Property Info</app-divider>

    <app-key-value-item
      label="Bedrooms"
      :value="property.bedrooms"
    ></app-key-value-item>

    <app-key-value-item
      label="Bathrooms"
      :value="property.bathrooms"
    ></app-key-value-item>

    <app-key-value-item
      label="House Size"
      :value="property.house_size"
    ></app-key-value-item>

    <app-key-value-item
      label="Parking Type"
      :value="property.parking_type"
    ></app-key-value-item>

    <app-key-value-item
      label="Year Built"
      :value="property.year_built"
    ></app-key-value-item>

    <app-key-value-item
      label="Market Value"
      is-currency
      :value="property.market_value"
    ></app-key-value-item>

    <app-key-value-item
      label="Assessed Value"
      is-currency
      :value="property.assessed_value"
    ></app-key-value-item>

    <app-key-value-item
      label="Basement Size"
      :value="property.basement_size"
    ></app-key-value-item>

    <app-key-value-item
      label="Lot Size"
      :value="property.lot_size"
    ></app-key-value-item>

    <app-key-value-item
      label="Stories"
      :value="property.stories"
    ></app-key-value-item>

    <app-key-value-item
      label="Cooling Type"
      :value="property.cooling_type"
    ></app-key-value-item>

    <app-key-value-item
      label="Heating Type"
      :value="property.heating_type"
    ></app-key-value-item>

    <app-key-value-item
      label="Construction Type"
      :value="property.construction_type"
    ></app-key-value-item>

    <app-key-value-item
      label="Architecture Type"
      :value="property.architecture_type"
    ></app-key-value-item>

    <app-key-value-item
      label="Subdivision"
      :value="property.subdivision"
    ></app-key-value-item>

    <app-key-value-item
      label="Amenities"
      :value="property.amenities"
    ></app-key-value-item>

    <app-divider class="my-150">Lead Info</app-divider>

    <app-key-value-item
      v-for="field in customFields"
      :key="field.id"
      :label="field.label"
      :value="field.value"
      :is-date="field.type === ENUMS.CustomFieldTypeEnum.Date.value"
      :is-currency="field.type === ENUMS.CustomFieldTypeEnum.Currency.value"
      :is-url="field.type === ENUMS.CustomFieldTypeEnum.Url.value"
    ></app-key-value-item>
  </div>
</template>

<script>
import CommLogItem from "../../../components/comms/components/CommLogItem";

export default {
  name: "InboxContentNewLead",
  components: {CommLogItem},
  computed: {
    record() {
      return this.$store.getters["activeInboxLeadItem/record"];
    },
    property() {
      return this.$store.getters["activeInboxLeadItem/property"];
    },
    comms() {
      const comms = this.$store.getters["activeInboxLeadItem/communicationLogs"]
      return comms.sort((a, b) => new Date(a.scheduled_at) - new Date(b.scheduled_at));
    },
    allCustomFields() {
      // NOTE: If you want to show historical custom fields than change this to recordCustomFieldsWithTrashed
      return this.$store.getters.recordCustomFields;
    },
    recordCustomFields() {
      return this.record.custom_fields;
    },
    customFields() {
      let customFields = this.allCustomFields.map(customField => {
        const recordField = this.recordCustomFields.find(field => field.id === customField.id);

        return {
          id: customField.id,
          order: customField.order,
          value: (recordField) ? recordField.value : '--', //customField.default_value,
          type: customField.type,
          customFieldableType: customField.custom_fieldable_type,
          label: customField.label,
          options: customField.options,
          visible: customField.visible
        };
      });

      return customFields.sort((a, b) => a.order - b.order);
    },
  },
};
</script>
